import { ClientCategories } from "../types/categories";
import { ApiCategories } from "../types/categories/api-types";

export const categoriesAdapter = {
  toClientCategories(apiCategories: ApiCategories): ClientCategories {
    return apiCategories.map((category) => ({
      id: category.id,
      categoryName: category.category_name,
      subcategories: category.subcategories?.map((subcategory) => ({
        id: subcategory.id,
        categoryName: subcategory.category_name,
      })),
    }));
  },
};
